const Spacer = () => {
  return (
    <div className="shrink-0 border-t border-[#A3A3A3] data-[orientation=horizontal]:h-px data-[orientation=vertical]:h-full data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px" />
  );
};

export default Spacer;
